import { initialValidSections } from 'components/pages/jobForm/framework/config';
import { AUTHENTICATION_KEY } from 'constants/authConstants';
import * as key from '../store/constants';

// initial state
const initialState = {
  [key.AUTH]: {
    [AUTHENTICATION_KEY]: false
  },
  [key.CUSTOMER_PERMISSIONS]: {},
  [key.POST_MESSAGE]: {
    PAGE_CHANGE: {
      RAILS_NAVIGATION: null
    }
  },
  [key.TRYOUT_BADGES]: [],
  [key.FILL_ADVISOR_DATA]: {},
  [key.PAGING]: {},
  [key.USER]: {},
  [key.FEATURE_USER_SETTINGS]: {},
  [key.ALERTS]: {},
  [key.ERRORS]: {},
  [key.LOADING]: {},
  [key.SORT]: {},
  [key.MAGIC_ALGORITHM]: {},
  [key.JOB_FORM_ACTIVE_SECTION]: {},
  [key.JOB_FORM_VALID_SECTIONS]: initialValidSections,
  [key.REQUIREMENTS_TAGS]: null,
  [key.THEME]: {},
  [key.MESSAGES_PAGE]: {
    selectAll: false
  },
  [key.WANDAS_PAGE]: {},
  [key.PREFERRED_MODAL]: {}
};

export default initialState;
